import {BooksActionCreators} from './books/booksActionCreators';

export const allActionCreators = {
    ...BooksActionCreators,
}